import {
  AppBar,
  Box,
  Button,
  Grid,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { useHistory, useParams } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import { TabPanel } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenSelectWrap from '../../../../global_components/KenSelect';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { Link } from 'react-router-dom';
import {
  RiFilterLine,
  RiCheckFill,
  RiNotification2Fill,
  RiNotification3Line,
} from 'react-icons/ri';
import { Message } from '@material-ui/icons';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import KenSelect from '../../../../global_components/KenSelect';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import {
  getInvigilator_s1_Data,
  getInvigilator_s1_Datas,
  getInvigilator_s2_Data,
  postInvigilator_s2_Data,
} from '../../../../Utils/apiServices';
import { sendMailInvigilator } from '../../../../Utils/sendMail';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'INVIGILATION AND PROCTORING ASSIGNMENT',
  },
];
export const AssignDropDown = [
  {
    label: 'Assigned',
    value: 'Assigned',
  },
  {
    label: 'Not Assigned',
    value: 'Not Assigned',
  },
];
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: '#EB5757',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: '#FFFFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: '#979797',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#F2994A',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCourse = [
  {
    label: 'Automatic',
    value: 'Automatic',
  },
  {
    label: 'Manually',
    value: 'Manually',
  },
];

const InvigilationAssign = () => {
  function TabPanels(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  const CustomTableCell = ({ row, name, onChange }) => {
    const classes = useStyles();
    const { isEditMode } = row;
    return (
      <TableCell align="left" className={classes.tableCell}>
        {isEditMode ? (
          <Input
            value={row[name]}
            name={name}
            onChange={(e) => onChange(e, row)}
            className={classes.input}
          />
        ) : (
          row[name]
        )}
      </TableCell>
    );
  };
  const CustomTableCellForDropDown = ({ row, name, onChange }) => {
    const { isEditMode } = row;
    console.log('row', row[name]);

    return (
      <TableCell align="left">
        {isEditMode ? (
          <Box>
            <KenSelect
              name={name}
              options={AssignDropDown}
              value={row[name]}
              dropdownColor="#ffffff"
              onChange={(e) => onChange(e, row)}
              required={true}
            />
          </Box>
        ) : (
          row[name]
        )}
      </TableCell>
    );
  };

  const CustomTableCellForDate = ({ row, name, onChange }) => {
    const classes = useStyles();
    const { isEditMode } = row;
    return (
      <TableCell align="left" className={classes.tableCell}>
        {isEditMode ? (
          <KenDateTimePicker
            name={name}
            label="Start Date"
            inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="Start Date"
            value={row[name]}
            type="date"
            required={true}
            // defaultValue={startDate}
            onChange={(e) => onChange(e, row)}
          />
        ) : (
          row[name]
        )}
      </TableCell>
    );
  };
  const CustomTableCellForTime = ({ row, name, onChange }) => {
    const classes = useStyles();
    const { isEditMode } = row;
    return (
      <TableCell align="left" className={classes.tableCell}>
        {isEditMode ? (
          <KenDateTimePicker
            name={name}
            label="Start Time"
            inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="Start Time"
            value={row[name]}
            type="time"
            required={true}
            // defaultValue={startTime}
            onChange={(e) => onChange(e, row)}
          />
        ) : (
          row[name]
        )}
      </TableCell>
    );
  };
  // let { Exam_id_id, id } = useParams();
  let Exam_id_id = useParams();
  console.log('Exam_id_idExam_id_idExam_id_id--------------', Exam_id_id.id);
  const [previous, setPrevious] = useState({});
  const onChange = (e, row) => {
    console.log('data', row.id, rows, e.target.value, e.target.name);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };
  // const onToggleEditMode = (check, id, index) => {
  //   const newData = [...rows];
  //   setRows((state) => {
  //     return newData.map((row) => {
  //       if (row.id === id) {
  //         if (check === 'done') {
  //           row.isEditMode = true;
  //           const payload = [
  //             {
  //               facultyId: row.id,
  //               roomNo: row.assign_to,
  //               examId: Exam_id_id.id,
  //               facEmail: row.calories,
  //               subject: row.carbs,
  //               isAllocated: row.venue_link,
  //             },
  //           ];
  //           console.log('payloadpayload', payload);
  //           postInvigilator_s2_Data(payload)
  //             .then((res) => {
  //               if (res.success === 'true' || true) {
  //                 // alert(res.message);
  //                 row.isEditMode = false;
  //                 getInvigilator_s2_DataListing();
  //               }
  //               row.isEditMode = false;
  //             })
  //             .catch((err) => {
  //               console.log('Failed to add. Please try again.', err);
  //               row.isEditMode = false;
  //             });
  //         }
  //         if (check === 'edit') {
  //           return { ...row, isEditMode: !row.isEditMode };
  //         }
  //       }
  //       return row;
  //     });
  //   });
  // };
  const onToggleEditMode = (id) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };
  const createData = (name, carbs, assign_to, venue_link) => ({
    id: name.replace(' ', '_'),
    name,
    carbs,
    // capacity,
    assign_to,
    venue_link,

    isEditMode: false,
  });
  const [rows, setRows] = useState([]);
  const history = useHistory();
  const classes = useStyles();
  const SEATING_COLUMNS = 6;

  //Get Data from API through params : id
  const currentSeatingPlanData = {
    id: 1,
    course: 'Course 1',
    subject: 'Subject 1',
    candicate: '100',
    date: new Date(), // Date from api
    start_time: '10:30 AM',
    duration: '2',
    exam_type: 'Offline',
  };

  // Tab Panel states
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // Automatic select
  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const [Rooms, setRooms] = useState();
  const [respData, setRespData] = useState({});

  let nameForCourse;
  // onDataSave = () => {};
  const saveData = () => {
    console.log('object');
    const newData = [...rows];

    const payload = newData.map((row) => {
      return {
        facultyId: row.id,
        roomNo: row.assign_to,
        examId: Exam_id_id.id,
        facEmail: row.calories,
        subject: row.carbs,
        isAllocated: row.venue_link,
        sendEmail: false,
      };
    });
    setRespData({ success: 'true', message: 'Data updated Successfully' });
    postInvigilator_s2_Data(payload)
      .then((res) => {
        /* enable on res success */
        // setRespData(res)
        getInvigilator_s2_DataListing();
      })
      .catch((err) => {
        alert('Failed to add. Please try again.');
      });
  };
  /* send mail  */
  useEffect(() => {
    if (respData.success === 'true') {
      sendMailInvigilator();
    }
  }, [respData]);
  const getInvigilator_s2_DataListing = () => {
    getInvigilator_s1_Datas();

    let filterData = {
      id: Exam_id_id.id,
    };

    getInvigilator_s2_Data(filterData).then((res) => {
      console.log('reresresresresress', res);
      const EvaluationDetailsInfo =
        res === null
          ? []
          : res.map((item, index) => {
              console.log('itemitem', item);
              const data = item?.facultyList?.map((item) => {
                let subjectName = item.subject
                  ? item.subject.map((e) => e.courseName).join('\n')
                  : '';

                // let dataToArray = subjectName
                //   .split(',')
                //   .map((item) => item.trim());

                // let datassss = dataToArray.join('\n');
                // console.log('dataToArraydataToArray', dataToArray);
                // console.log('datassssdatassssdatassss', datassss);
                let roomNo = item.roomNo ? item.roomNo.map((e) => e) : '';
                return {
                  button: 'assign',
                  faucltyId: item.faucltyId,
                  id: item.faucltyId,

                  name: item.name ? item.name : '',
                  calories: item.facEmail ? item.facEmail : '',
                  carbs: subjectName ? subjectName : '',
                  // capacity: '',
                  assign_to: item.allocatedRoomNo ? item.allocatedRoomNo : '',
                  venue_link: item.isAllocated ? item.isAllocated : '',
                };
              });
              return data;
            });

      console.log(
        'EvaluationDetailsInfoEvaluationDetailsInfoEvaluationDetailsInfo',
        EvaluationDetailsInfo
      );
      const EvaluationDetailsInfosss =
        res === null
          ? []
          : res.map((item, index) => {
              // let roomAllocted = [];
              // item.facultyList.map((map) => {
              //   return roomAllocted.push(map.allocatedRoomNo);
              // });

              // item.roomNo = item.roomNo.filter(
              //   (val) => !roomAllocted.includes(val)
              // );

              let subjectName = item.roomNo
                ? item.roomNo.map((e) => {
                    return { label: e, value: e };
                  })
                : '';

              return subjectName;
            });
      setRooms(EvaluationDetailsInfosss);

      setRows(EvaluationDetailsInfo[0]);
    });
  };

  const CustomTableCellForDropDownAssignto = ({ row, name, onChange }) => {
    const { isEditMode } = row;

    return (
      <TableCell align="left">
        {isEditMode ? (
          <Box>
            <Box>
              <KenSelect
                name={name}
                options={Rooms[0]}
                value={row[name]}
                dropdownColor="#ffffff"
                onChange={(e) => onChange(e, row)}
                required={true}
              />
            </Box>
          </Box>
        ) : (
          row[name]
        )}
      </TableCell>
    );
  };

  useEffect(() => {
    getInvigilator_s2_DataListing();
  }, []);

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Invigilation and proctoring Assignment
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              onClick={saveData}
              // className={classes.addButton}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar
        position="static"
        elevation={0}
        className={classes.header}
        style={{ margin: '20px 0' }}
      >
        <Toolbar style={{ color: '#505F79', fontWeight: 'bold' }}>
          {/* <Typography variant="p" style={{ marginRight: '25px' }}>
            {currentSeatingPlanData.course}
          </Typography> */}
          {console.log(
            'rowsrowsrowsrowsrowsrowsrowsrowsssssssssssss',
            nameForCourse
          )}
          <Typography variant="p"> BBAECO103-Macroeconomics </Typography>
          <Grid
            item
            xs={12}
            sm={2}
            style={{
              marginLeft: '600px',
            }}
          ></Grid>
        </Toolbar>
      </AppBar>

      <div className="cardlsitbox">
        <Box className={`cardlsitbox`}>
          <KenCard elevation={0}>
            <Table className={classes.table} aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">INVIGILATOR NAME</TableCell>
                  {/* <TableCell align="left">FACULTY HISTORY</TableCell> */}
                  <TableCell align="left">COURSE</TableCell>

                  <TableCell align="left">ROOM ALLOTMENT</TableCell>
                  <TableCell align="left">ASSIGN TO</TableCell>

                  {/* <TableCell align="left">FACULTY CAPACITY</TableCell> */}
                  <TableCell align="left">EDIT</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.faucltyId}>
                    {console.log('rowrowrowrowssssss', row)}
                    <TableCell>{row.name}</TableCell>
                    {/* <TableCell>{row.calories}</TableCell> */}
                    <TableCell>{row.carbs}</TableCell>
                    <CustomTableCellForDropDownAssignto
                      {...{ row, name: 'assign_to', onChange }}
                    />
                    <CustomTableCellForDropDown
                      {...{ row, name: 'venue_link', onChange }}
                    />
                    {/* <TableCell>{row.capacity}</TableCell> */}
                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() => onToggleEditMode(row.id)}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="delete"
                          onClick={() => onToggleEditMode(row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </KenCard>
        </Box>
      </div>
    </Box>
  );
};

export default InvigilationAssign;
